import {
  CategoriePublicCDPI,
  CategoriePublicCIPI,
  CategoriePublicLibelle,
  TypeQualificationCDPI,
  TypeQualificationCIPI,
  TypeQualificationLibelle
} from '@/features/domaine/types/opco/Demande/CXPI'
import type { DropdownItem } from '@designSystem/components'

//import { objectToDropdownItems } from '@/features/interface/shared/tools'
// export const diplomeItems = objectToDropdownItems(DiplomeLibelle)

export const categoriePublicCDPIItems =
  CategoriePublicCDPI.map<DropdownItem<string>>(id => ({ id, label: CategoriePublicLibelle[id] }))

export const categoriePublicCIPIItems =
  CategoriePublicCIPI.map<DropdownItem<string>>(id => ({ id, label: CategoriePublicLibelle[id] }))

export const typeQualificationCDPIItems =
  TypeQualificationCDPI.map<DropdownItem<string>>(id => ({ id, label: TypeQualificationLibelle[id] }))

export const typeQualificationCIPIItems =
  TypeQualificationCIPI.map<DropdownItem<string>>(id => ({ id, label: TypeQualificationLibelle[id] }))
